
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header>\n    <h1 id=\"fxa-400-header\" class=\"card-header\">{{#t}}Bad Request{{/t}}</h1>\n  </header>\n\n  <section>\n    <div class=\"error visible\">{{message}}</div>\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  